export const userProfileMenu = [
  { id: 0, text: 'Profile Settings', link: '/profile/profile-settings' },
  { id: 1, text: 'Work Preferences', link: '/profile/work-preferences' },
  { id: 2, text: 'Account Settings', link: '/profile/account-settings' },
  { id: 3, text: 'Notifications Settings', link: '/profile/notifications-settings' },
  { id: 4, text: 'Company Memberships', link: '/profile/company-memberships', recruiterOnly: true },
];

export const userProfileExternalMenu = [
  { id: 4, text: 'Help Center', link: '/profile/help-center', endIcon: false, target: '_self' },
  { id: 5, text: 'Terms of Use', link: 'termsAndConditions', endIcon: true, target: '_blank' },
  { id: 6, text: 'Privacy Policy', link: 'privacyPolicy', endIcon: true, target: '_blank' },
];

export const accordionFAQRecruiterData = [
  {
    id: 'panel1bh-header',
    expandedId: 'panel1',
    ariaControls: 'panel1bh-content',
    title: 'How does Injobnito match candidates to my job postings?',
    description:
      'Injobnito matches candidates based on their skills, qualifications, and job preferences that align with your job requirements. Our algorithm focuses on key factors such as experience, industry relevance, and skill fit—while keeping candidate identities anonymous until they choose to reveal them.',
  },
  {
    id: 'panel2bh-header',
    expandedId: 'panel2',
    ariaControls: 'panel2bh-content',
    title: 'What information will I see about candidates?',
    description:
      'You will see candidates skills, qualifications, experience level, and job preferences—without any personal identifiers such as names or photos. This ensures unbiased hiring decisions while focusing on what truly matters: their abilities and potential.',
  },
  {
    id: 'panel3bh-header',
    expandedId: 'panel3',
    ariaControls: 'panel3bh-content',
    title: 'Can I directly contact candidates through the platform?',
    description:
      'Yes, you can communicate with them through our secure messaging system. Their identity remains protected until they choose to disclose their details during the hiring process.',
  },
  {
    id: 'panel4bh-header',
    expandedId: 'panel4',
    ariaControls: 'panel4bh-content',
    title: 'How do I customize job postings to attract the right candidates?',
    description:
      'To attract the best candidates, make sure your job posting clearly outlines required skills, qualifications, and expectations. Use specific job categories, include key responsibilities, and set realistic salary ranges to improve the quality of matches.',
  },
  {
    id: 'panel5bh-header',
    expandedId: 'panel5',
    ariaControls: 'panel5bh-content',
    title: 'How does Injobnito ensure fair and unbiased hiring?',
    description:
      'Injobnito removes personal identifiers such as name, gender, and photos from candidate profiles to minimize unconscious bias. Our platform focuses solely on skills and experience, ensuring every candidate is evaluated based on their professional qualifications.',
  },
  {
    id: 'panel6bh-header',
    expandedId: 'panel6',
    ariaControls: 'panel6bh-content',
    title: 'How can I track the status of my job postings and applications?',
    description:
      'You can track all job postings and incoming applications from your recruiter dashboard. The dashboard provides insights into application status, candidate progress, and allows you to manage and shortlist candidates efficiently.',
  },
];

export const accordionFAQJobSeekerData = [
  {
    id: 'panel1bh-header',
    expandedId: 'panel1',
    ariaControls: 'panel1bh-content',
    title: 'How does Injobnito match me with jobs?',
    description:
      'Injobnito matches you with jobs based on your skills, experience, and job preferences such as location, salary range, and qualifications. Our smart matching algorithm analyzes your profile and compares it with job requirements to provide the best-fit opportunities—without revealing personal identifiers to employers.',
  },
  {
    id: 'panel2bh-header',
    expandedId: 'panel2',
    ariaControls: 'panel2bh-content',
    title: 'Why do you need my full name if the platform is anonymous?',
    description:
      'We collect your full name to verify that profiles on Injobnito are genuine and to prevent fraudulent accounts. However, your name remains private and is never shared with employers unless you choose to do so during the hiring process.',
  },
  {
    id: 'panel3bh-header',
    expandedId: 'panel3',
    ariaControls: 'panel3bh-content',
    title: 'Can I change my job preferences after setting up my profile?',
    description:
      'Yes! You can update your job preferences anytime by going to your account settings and selecting "Edit Profile." Here, you can adjust details like job category, salary expectations, location preferences, and skills to ensure you receive the most relevant job matches.',
  },
  {
    id: 'panel4bh-header',
    expandedId: 'panel4',
    ariaControls: 'panel4bh-content',
    title: 'Who can see my profile details?',
    description:
      'Your profile information, such as your skills, experience, and job preferences, is visible to potential employers anonymously. Personal details like your name and contact information remain hidden until you choose to share them when applying for a job or engaging with an employer.',
  },
  {
    id: 'panel5bh-header',
    expandedId: 'panel5',
    ariaControls: 'panel5bh-content',
    title: 'How do I update my demographic information?',
    description:
      'To update your demographic information, navigate to your account settings and select "Demographic Information." You can edit or remove details at any time. This data is used solely for statistical insights and to enhance platform inclusivity—it will never be shared with employers.',
  },
  {
    id: 'panel6bh-header',
    expandedId: 'panel6',
    ariaControls: 'panel6bh-content',
    title: 'How can I improve my job matches on Injobnito?',
    description:
      'To improve your job matches, make sure your profile is fully completed with accurate job preferences, skills, and experience. Regularly update your job category, location preferences, and salary expectations to reflect your current goals. Engaging with job recommendations and applying to relevant roles also helps refine future matches.',
  },
];

export const notificationsMockData = [
  {
    sectionTitle: 'In-app notifications visibility',
    sectionSubTitle: 'Notifications are delivered within the application.',
    separator: true,
    items: [
      /* { name: 'newMessagesApp', label: 'New messages' }, */
      { name: 'jobApplicationStatusApp', label: 'Job application status' },
    ],
  },
  {
    sectionTitle: 'Email notifications visibility',
    sectionSubTitle: 'Sent to your primary email address',
    separator: false,
    items: [
      /* { name: 'newMessagesEmail', label: 'New messages' }, */
      { name: 'jobApplicationStatusEmail', label: 'Job application status' },
    ],
  },
];
